export const BANNER = 'banner';
export const SCAN_TO_PRINT = 'scan-to-print';
export const CREATE_LABEL = 'create-label';
export const PROCESS_BATCH = 'process-batch';
export const LABEL_PURCHASE_BUTTON = 'label-purchase-button';
export const V1_API_KEYS = 'v1-api-keys';
export const V2_API_KEYS = 'v2-api-keys';
export const WALLET_REGISTRATION = 'wallet-registration';
export const UNKNOWN = 'unknown';
